import React from "react";
import { cn } from "../../lib/utils";
import { ArrowUpRight } from "lucide-react";
/**
 * ExternalLinkIcon Atom - SVG icon for external links
 * @component
 */
export const ExternalLinkIcon = ({ w = 5, h = 5 }) => (
    <ArrowUpRight className={`w-${w} h-${h}`} />
);

/**
 * ExternalLink Molecule - Link component for external URLs
 * Automatically includes security attributes and external link icon
 * 
 * @component
 * @example
 * <ExternalLink href="https://example.com">Visit Site</ExternalLink>
 * <ExternalLink href="https://example.com" showIcon={false}>No Icon</ExternalLink>
 */
const ExternalLink = ({
    href,
    children,
    className = "",
    showIcon = true,
    iconW = 5,
    iconH = 5,
    iconPosition = "right",
    ...props
}) => {
    if (!href) {
        return null;
    }

    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={cn("inline-flex items-center gap-2", className)}
            {...props}
        >
            {showIcon && iconPosition === "left" && <ExternalLinkIcon w={iconW} h={iconH} />}
            {children}
            {showIcon && iconPosition === "right" && <ExternalLinkIcon w={iconW} h={iconH} />}
        </a>
    );
};

export default ExternalLink;
